<template>
  <div>
    <v-layout
      class="mt-5"
      v-if="isLoading"
      align-center="align-center"
      justify-center
      column
      fill-height="fill-height"
    >
      <v-progress-circular size="70" width="7" color="purple" indeterminate="indeterminate">
      </v-progress-circular>
      <div>Loading...</div>
    </v-layout>
    <div v-if="!isLoading">
      <v-card tile flat>
        <v-toolbar class="elevation-0" height="45" color="gray">
          <v-toolbar-title>
            <h1 class="subtitle-1">{{ $t("pageHeader.editUser") }}</h1>
          </v-toolbar-title>
          <v-spacer> </v-spacer>
          <h1 class="subheading mr-1" v-if="currentUser.accountTypeID <= 2">
            {{ $t("labels.active") }}
          </h1>
          <toggle-button
            :labels="true"
            v-model="User.isActive"
            :sync="true"
            v-if="currentUser.accountTypeID <= 2"
          >
          </toggle-button>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col class="shrink">
              <img
                class="br-50"
                width="140"
                height="160"
                v-if="imageUrl"
                :src="imageUrl"
                alt="User"
              />
              <img
                class="br-50"
                width="140"
                height="160"
                v-else
                src="../../../assets/images/user.jpeg"
                alt="User"
              />
              <v-row>
                <v-col class="shrink">
                  <v-btn fab="fab" color="red">
                    <v-icon color="white" @click="removeImage">delete</v-icon>
                  </v-btn>
                </v-col>
                <v-col class="shrink">
                  <v-btn fab="fab" color="info" @click="pickFile">
                    <v-icon color="white">attach_file </v-icon>
                  </v-btn>
                </v-col>
                <input
                  type="file"
                  ref="image"
                  style="display: none"
                  accept="image/*"
                  @change="onFilePicked"
                />
              </v-row>
            </v-col>
            <v-col>
              <h1 class="display-1 font-weight-regular">{{ User.fullName }}</h1>
              <h2 class="title font-weight-light">{{ User.loginEmail }}</h2>
              <h2 class="caption mt-1">{{ accountName }}</h2>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider> </v-divider>
        <v-card-text>
          <v-subheader>{{ $t("pageHeader.userInformation") }}</v-subheader>
          <v-row>
            <v-col sm="12" md="6">
              <v-text-field
                outlined
                dense
                :error-messages="fullNameErrors"
                :hide-details="fullNameErrors.length === 0"
                v-model="User.fullName"
                label="Full name"
              >
              </v-text-field>
            </v-col>
            <v-col sm="12" md="6">
              <v-text-field
                outlined
                dense
                :hide-details="loginEmailErrors.length === 0"
                :error-messages="loginEmailErrors"
                label="Login Email"
                v-model="User.loginEmail"
              >
              </v-text-field>
            </v-col>
            <v-col sm="12" md="6">
              <v-text-field
                outlined
                hide-details
                dense
                label="Alternate Email"
                v-model="User.alternativeEmail"
              >
              </v-text-field>
            </v-col>
            <v-col sm="12" md="6">
              <v-text-field
                outlined
                hide-details
                dense
                v-model="User.loginPassword"
                label="Login Password"
                type="password"
              >
              </v-text-field>
            </v-col>
            <v-col sm="12" md="6">
              <v-text-field
                outlined
                dense
                hide-details
                label="Phone Number"
                v-model="User.phoneNumber"
              >
              </v-text-field>
            </v-col>
            <v-col sm="12" md="6">
              <v-text-field outlined dense hide-details label="Address" v-model="User.address">
              </v-text-field>
            </v-col>
            <v-col sm="12" md="4">
              <v-text-field outlined dense hide-details label="City" v-model="User.city">
              </v-text-field>
            </v-col>
            <v-col sm="12" md="4">
              <v-text-field outlined dense hide-details label="State" v-model="User.state">
              </v-text-field>
            </v-col>
            <v-col sm="12" md="4">
              <v-text-field outlined dense hide-details label="Zipcode" v-model="User.zipcode">
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider> </v-divider>
        <v-card-actions>
          <v-spacer> </v-spacer>
          <v-btn color="blue darken-1" text @click="cancel">Cancel</v-btn>

          <v-btn color="blue darken-1" dark @click="update">update</v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import userService from "../service.js";
const { validationMixin } = require("vuelidate");
const { required, minLength, minValue, sameAs, email } = require("vuelidate/lib/validators");

export default {
  name: "edit-User",
  data() {
    return {
      imageName: "",
      imageUrl: "",
      imageFile: "",
      accountType: [],
      userRightCatalog: [],
      assignedRight: null,
      userRightsArray: [],
      accountName: null,
      isLoading: true,
      User: {
        userName: null,
        fullName: null,
        phoneNumber: null,
        loginEmail: null,
        loginPassword: null,
        address: null,
        city: null,
        state: null,
        zipcode: null,
        alternativeEmail: null,
        isActive: true,
        userRights: null,
        imageUrl: null,
        image: null,
        accountTypeID: null
      },
      rights: [],
      givenRightsArray: []
    };
  },
  mixins: [validationMixin],
  validations: {
    User: {
      fullName: {
        required,
        minLength: minLength(2)
      },
      loginEmail: {
        required,
        email
      },
      accountTypeID: {
        required
      }
    }
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    fullNameErrors() {
      const errors = [];
      if (!this.$v.User.fullName.$dirty) return errors;
      if (!this.$v.User.fullName.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.User.fullName.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    },
    loginEmailErrors() {
      const errors = [];
      if (!this.$v.User.loginEmail.$dirty) return errors;
      if (!this.$v.User.loginEmail.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.User.loginEmail.email) errors.push(this.$t("validations.emailIsNotValid"));
      return errors;
    },
    accountTypeIDErrors() {
      const errors = [];
      if (!this.$v.User.accountTypeID.$dirty) return errors;
      if (!this.$v.User.accountTypeID.required) errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    assignedRights() {
      var temp = this.rights.filter(rights => rights.assigned == true);
      return temp.length;
    },
    progress() {
      return (this.assignedRights / this.rights.length) * 100;
    },
    unassignedRights() {
      return this.rights.length - this.assignedRights;
    }
  },
  async created() {
    await this.getAllUserRights();
    await this.getAllAccountType();
    await this.loadUser();
  },
  watch: {
    imageUrl(val) {
      this.User.image = val;
    }
  },
  methods: {
    async loadUser() {
      if (!this.$route.params || !this.$route.params.id) return this.$router.push("/user/list");
      const id = this.$route.params.id;
      if (this.currentUser.userID === id) {
        await this.getUserById(id);
      } else {
        if (this.currentUser.accountTypeID <= 2) {
          await this.getUserById(id);
        } else {
          await this.getUserById(this.currentUser.userID);
        }
      }

      // this.setPreAssignedRights()
    },
    setPreAssignedRights() {
      let rights = this.User.userRights.split(",");
      rights.map(x => {
        this.rights.map(y => {
          if (y.rightID == x) {
            this.givenRightsArray.push(y);
          }
        });
      });
    },
    getUserById(id) {
      return userService.getById(id).then(response => {
        console.log("response", response);
        this.User = response;
        this.User.loginPassword = null;
        this.accountName = this.User.AccountType.accountTypeName;
        this.imageUrl = this.User.imageUrl;
        this.isLoading = false;
        return;
      });
    },
    pickFile() {
      this.$refs.image.click();
    },
    removeImage() {
      this.imageUrl = "";
      this.User.imageUrl = null;
      this.User.image = null;
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    },
    addRight(obj) {
      let foundit = false;
      this.givenRightsArray.map(row => {
        if (row.rightID === obj.rightID) {
          foundit = true;
        }
      });
      if (!foundit) {
        this.givenRightsArray.push(obj);
      } else {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            type: "error",
            title: "Right already exists"
          });
      }
    },
    removeRight(item) {
      let index = this.givenRightsArray.findIndex(x => x.rightID === item.rightID);
      this.givenRightsArray.splice(index, 1);
    },
    cancel() {
      this.$router.go(-1);
    },
    // assignRightsByType (obj){
    //   this.accountName = obj.accountTypeName
    //   this.givenRightsArray = []
    //   this.rights.map(right => {
    //     let accounts = right.accountTypeID.split(",")
    //     accounts.map(account => {
    //       if(account == obj.accountTypeID) this.givenRightsArray.push(right)
    //     })
    //   })
    //   this.User.accountTypeID = obj.accountTypeID
    // },
    getAllUserRights() {
      return userService.getAllUserRights().then(result => {
        this.rights = result.data;
      });
    },
    getAllAccountType() {
      return userService.getAllAccountType().then(result => {
        this.accountType = result.data;
      });
    },
    update() {
      let newRights = [];
      this.givenRightsArray.map(x => {
        newRights.push(x.rightID);
      });
      this.User.userRights = newRights.toString();
      this.User.userName = this.User.fullName;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            type: "error",
            title: this.$t("toastMessage.text.invalidFields")
          });
      } else {
        if (this.User.image != null && this.User.image.substring(0, 4) === "http") {
          delete this.User.image;
        }
        return userService
          .update(this.User.userID, { User: this.User })
          .then(result => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  type: "success",
                  title: "User Updated!"
                });
              this.$store.dispatch("global/initUser");
              this.$router.go(-1);
            }
          })
          .catch(err => {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              })
              .fire({
                type: "error",
                title: err.data.data
              });
          });
      }
    }
  }
};
</script>

<style>
.imgSize {
  width: 120px;
  height: 180px;
}
</style>
